import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './MachinesPage.css';
import { ArrowIcon, Magnetic, Reveal, SplitText } from './motion';
import { CATEGORY_ORDER, MACHINE_CATEGORIES } from '../data/machines';

const MachinesPage = ({ category }) => {
  const { t } = useTranslation();
  const { groups } = MACHINE_CATEGORIES[category];

  const machineName = (name) => (typeof name === 'string' ? name : t(`machines.names.${name.key}`));
  const specValue = (v) => (typeof v === 'string' ? v : t(`machines.values.${v.key}`));

  return (
    <>
      <section className="mpage-hero section--dark">
        <div className="container">
          <Reveal y={10}>
            <Link to="/#services" className="mpage-hero__back">
              <span aria-hidden="true">←</span> {t('machines.back')}
            </Link>
          </Reveal>
          <SplitText as="h1" text={t(`machines.${category}.title`)} className="mpage-hero__title" />
          <Reveal as="p" className="mpage-hero__desc" delay={0.15}>
            {t(`machines.${category}.desc`)}
          </Reveal>

          <Reveal as="nav" className="mpage-tabs" delay={0.25} aria-label={t('machines.eyebrow')}>
            {CATEGORY_ORDER.map((key) => (
              <Link
                key={key}
                to={MACHINE_CATEGORIES[key].path}
                className={`mpage-tabs__item ${key === category ? 'is-active' : ''}`}
                aria-current={key === category ? 'page' : undefined}
              >
                {t(`services.${key}.name`)}
              </Link>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="section section--light mpage-body">
        <div className="container">
          {groups.map((group, gi) => (
            <div className="mpage-group" key={gi}>
              {group.titleKey && (
                <Reveal as="h2" className="mpage-group__title">
                  {t(group.titleKey)}
                </Reveal>
              )}
              <ul className="mgrid">
                {group.items.map((m, i) => (
                  <Reveal as="li" key={i} className="mcard" delay={(i % 3) * 0.08}>
                    <div className="mcard__img">
                      <img src={m.image} alt={machineName(m.name)} loading="lazy" />
                    </div>
                    <div className="mcard__body">
                      <span className="mcard__idx">{String(i + 1).padStart(2, '0')}</span>
                      <h3 className="mcard__name">{machineName(m.name)}</h3>
                      {m.values && (
                        <dl className="mcard__specs">
                          {group.specs.map((spec, si) => (
                            <div className="mcard__row" key={spec}>
                              <dt>{t(`machines.specs.${spec}`)}</dt>
                              <dd>{specValue(m.values[si])}</dd>
                            </div>
                          ))}
                        </dl>
                      )}
                    </div>
                  </Reveal>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="section section--dark mpage-cta">
        <div className="container mpage-cta__inner">
          <div>
            <SplitText text={t('machines.ctaTitle')} className="mpage-cta__title" />
            <Reveal as="p" delay={0.1}>
              {t('machines.ctaText')}
            </Reveal>
          </div>
          <Magnetic>
            <Link to="/#contact" className="btn btn--accent">
              {t('nav.cta')}
              <ArrowIcon />
            </Link>
          </Magnetic>
        </div>
      </section>
    </>
  );
};

export default MachinesPage;
